import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { useTypedSelector } from '../hooks';
import { ErrorBoundaryLayout, authRoutes, nonAuthRoutes } from '.';

const Root = () => {
  const { refreshToken, accessToken } = useTypedSelector(state => state.auth);

  const routes = refreshToken && accessToken ? authRoutes : nonAuthRoutes;

  const router = createBrowserRouter([
    { element: <ErrorBoundaryLayout />, children: routes },
  ]);

  return <RouterProvider router={router} />;
};

export default Root;
